import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Bus from '@/util/eventBus';
import IconCancel from '@vip-activity/ui/components/icon/IconCancel.vue';
import HuoMask from '../HuoMask/HuoMask.vue';
export default {
  settingKey: '回忆视频',
  setting: {
    视频vid: ''
  },
  components: {
    IconCancel: IconCancel,
    HuoMask: HuoMask
  },
  data: function data() {
    return {
      playing: false
    };
  },
  created: function created() {
    Bus.$on('openVideo', this.play);
  },
  methods: {
    start: function start() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.setting.视频vid) {
                  if (window.Txplayer) {
                    _this.loadVideo();
                  } else {
                    document.addEventListener('TxPlayerJSBrageReady', function () {
                      _this.loadVideo();
                    });
                  }
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadVideo: function loadVideo() {
      var _this2 = this;

      var player = new Txplayer({
        containerId: 'recall_video',
        vid: this.setting.视频vid,
        width: '100%',
        height: '100%',
        isUsePreload: false,
        autoplay: true
      });
      player.on('playStateChange', function (status) {
        // 已结束
        if (status === 0) {
          _this2.closeVideo();
        }
      });
      this.player = player;
    },
    closeVideo: function closeVideo() {
      if (this.player) {
        // 播放出错时没有这些方法
        if (this.player.seekTo) {
          this.player.seekTo(0);
          this.player.pause();
        }

        this.playing = false;
      }
    },
    play: function play() {
      this.playing = true;

      if (this.player) {
        this.player.seekTo(0);
        this.player.play();
      } else {
        this.start();
      }
    },
    buyTicket: function buyTicket() {
      Bus.$emit('checkBuyTicket');
      this.closeVideo();
    }
  }
};